<template>
	<div style="width: 100%;height: 100%;background: #eceef1;">
		<Layout-Top border menuName="手机绑定" prevUrl="/WeChat/Person/Account">
		</Layout-Top>
		<!-- <Row type="flex" justify="center" align="center" style="height: 46px;width: 100%; background: #eceef1;line-height: 46px;">
			<Col span="2">
				<Icon style="margin-top: -2px;" size="28" type="ios-arrow-back" />
			</Col>
			<Col span="22">
				手机绑定 
			</Col>
		</Row>
		<Divider style="margin-top: 0px;height: 2px;" /> -->
		<div style="width: 100%;height: 210px;padding-top: 28px;">
			<div style="width: 166px;height: 166px;position: relative;margin: 0 auto;">
				<Icon size="166" type="ios-phone-portrait" />
				<div style="position: absolute; bottom: 20px;right: 32px;height: 46px;width: 46px;background: white;background: white;border-radius: 36px;" >
					<Icon style="margin-top: -8px;margin-left: -8px;" size="73" :color="binding?'#19be6b':'#ff9900'" :type="binding?'ios-checkmark-circle':'md-information-circle'" />
				</div>
			</div>
		</div>
		<div style="height: 36px;line-height:36px;width: 100%;text-align: center;font-size: 16px;margin-bottom: 26px;font-weight:600">
			{{binding?'当前绑定手机号:'+person.pphone:'你还未绑定手机号'}}
		</div>
		<Row type="flex" justify="center" align="center" style="height: 36px;">
			<Col span="2">
			</Col>
			<Col span="20">
				<Button @click="toPage('/WeChat/Person/Account/Phone/Binding')" size="large" long>{{binding?'更换手机号':'绑定手机号'}}</Button>
			</Col>
			<Col span="2">
			</Col>
		</Row>
	</div>
</template>
<script>
	import Top from '../../assembly'
	export default {
		components: {
			'Layout-Top': Top
		},
		data(){
			return {
				binding:true,
				person:{
					pphone:'15508313366'
				}
			}
		},
		methods:{
			toPage(page){
				this.$router.push(page);
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Account/Phone/index.vue